import { render, staticRenderFns } from "./CreateRmStockPopUp.vue?vue&type=template&id=631ab5ba&scoped=true&"
import script from "./CreateRmStockPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateRmStockPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateRmStockPopUp.vue?vue&type=style&index=0&id=631ab5ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ab5ba",
  null
  
)

export default component.exports